import StatusTag from '@/components/_common/StatusTag';
import { WorkOrderMigrateConsultItem } from '@/core/domain/workorder/WorkOrders/WorkOrders.types';
import {
  WorkOrderItemType,
  workorderTypeColor,
  workorderTypeItemSmall,
} from '@/core/domain/workorder/WorkOrdersItems/WorkOrdersItems.types';
import formatterNumber from '@/utils/number/formatterNumber';
import formatterPercent from '@/utils/number/formatterPercent';
import formatterPrice from '@/utils/number/formatterPrice';
import { Descriptions, Modal } from 'antd';

interface Props {
  item?: WorkOrderMigrateConsultItem;
  opened: boolean;
  onClose: VoidFunction;
}

export default function MigrationConsultItemDetailModal({
  item,
  ...props
}: Props) {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  let items: Record<string, any> = {
    ['Tipo']: item?.type ? (
      <StatusTag
        color={workorderTypeColor[item?.type]}
        label={workorderTypeItemSmall[item?.type]}
      />
    ) : (
      '-'
    ),
    ['Fabricante']: item?.manufacturer || '-',
    ['Cód. fabricante']: item?.manufacturingCode || '-',
    ['Área']: item?.subArea || '-',
    ['Fornecedor']: item?.supplier || '-',
    ['Quantidade']: formatterNumber(item?.quantity || 0) || '-',
    ['Preço unit.']: formatterPrice(item?.unitPrice || 0) || '-',
    ['Desconto(%)']: formatterPercent((item?.discount || 0) / 100) || '-',
    ['Desconto($)']: formatterPrice(
      (item?.quantity || 0) *
        (item?.unitPrice || 0) *
        ((item?.discount || 0) / 100),
    ),
    ['Custo unit.']: formatterPrice(item?.unitCost || 0),
  };

  if (item?.type === WorkOrderItemType.Service) {
    items = {
      ...items,
      ['Técnico responsável']: item?.employee || '-',
      ['Peça pintada']: item?.isPart ? 'Sim' : 'Não',
      ['Serviço tercerizado']: item?.isInternal ? 'Não' : 'Sim',
    };
  }

  if (item?.type === WorkOrderItemType.Part) {
    items = {
      ...items,
      ['Peça fornecida']: item?.isInternal ? 'Não' : 'Sim',
    };
  }

  return (
    <Modal
      open={props.opened}
      onCancel={props.onClose}
      title="Detalhe do item"
      width={600}
      cancelText="Fechar"
      okButtonProps={{ style: { display: 'none' } }}
    >
      <div style={{ marginBottom: 10 }}>
        <strong style={{ fontWeight: 600 }}>Descrição:</strong>
        <div>{item?.itemDescription}</div>
      </div>

      <Descriptions
        layout="vertical"
        labelStyle={{ fontWeight: 600 }}
        column={2}
      >
        {Object.entries(items).map(([label, content], index) => (
          <Descriptions.Item
            label={label}
            style={{ paddingBottom: 0 }}
            key={index}
            contentStyle={{ paddingBottom: 10 }}
          >
            {content}
          </Descriptions.Item>
        ))}
      </Descriptions>
    </Modal>
  );
}
